/* eslint-disable */
// @ts-nocheck

import { Search, X } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useDebounce } from '@/hooks/useDebounce'

interface SearchQueryProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  placeholder?: string
  onlyNumbers?: boolean
}

export const SearchQuery = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Buscar por número de factura...',
  onlyNumbers = false,
}: SearchQueryProps) => {
  const [searchValue, setSearchValue] = useState(searchQuery)

  // Debounce the search value to avoid excessive calls
  const debouncedSearchValue = useDebounce(searchValue, 1000)

  useEffect(() => {
    setSearchValue(searchQuery)
  }, [searchQuery])

  // Effect to call onSearchChange when debounced value changes
  useEffect(() => {
    if (debouncedSearchValue !== searchQuery) {
      onSearchChange(debouncedSearchValue)
    }
  }, [debouncedSearchValue, searchQuery, onSearchChange])

  // Memoized clear function to prevent unnecessary re-renders
  const handleClear = useCallback(() => {
    setSearchValue('')
    onSearchChange('')
  }, [onSearchChange])

  // Memoized input change handler
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onlyNumbers) {
        const value = e.target.value.replace(/[^0-9]/g, '')
        setSearchValue(value)
      } else {
        setSearchValue(e.target.value)
      }
    },
    [onlyNumbers]
  )

  return (
    <div className="relative min-w-[240px] flex-1">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        className="bg-white pl-9 pr-4"
        onChange={handleInputChange}
        placeholder={placeholder}
        value={searchValue}
      />
      {searchValue && (
        <Button
          className="absolute right-1 top-1.5 h-7 w-7"
          onClick={handleClear}
          size="icon"
          variant="ghost"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
